const diseasesData = {
  "HEALTHY": {
    description: `The prawn is in good health. Maintain proper water quality and feeding routines. Ensure regular monitoring to prevent potential infections. A healthy environment promotes better growth and survival rates.`,
    tips: [
      "Maintain good water quality.",
      "Provide a balanced diet to the prawns.",
      "Ensure proper aeration in the pond.",
      "Monitor for any abnormal behavior regularly."
    ]
  },

  "BLACK GILL": {
    description: `Black Gill Disease in shrimp causes darkened gills due to infections or poor water quality, leading to respiratory issues, reduced growth, and increased mortality. It can be triggered by bacteria, fungi, protozoa, and stressors like high ammonia or low oxygen. Prevention includes proper pond management, good aeration, and water quality control. Early detection and corrective actions, such as using probiotics, can help reduce its impact.`,
    tips: [
      "Regularly check water quality and aeration.",
      "Use probiotics to prevent bacterial infections.",
      "Remove any infected prawns immediately.",
      "Avoid overcrowding in the pond."
    ]
  },

  "WHITE SPOT": {
    description: `White Spot Disease (WSD), caused by the White Spot Syndrome Virus (WSSV), spreads through contaminated water and infected shrimp. It causes white spots, lethargy, and high mortality. Outbreaks are triggered by poor water quality and stress. With no cure, prevention through biosecurity, disease-resistant shrimp, and early detection is key.`,
    tips: [
      "Use SPF (Specific Pathogen-Free) shrimp.",
      "Maintain optimal water quality.",
      "Disinfect all equipment and water sources.",
      "Remove infected shrimp immediately to prevent spread."
    ]
  },

  "BLACK SPOT": {
    description: "Black Spot Disease in prawns is a bacterial or fungal infection that appears as dark lesions on the exoskeleton. It is caused by poor water quality, injuries, or secondary infections. While not always fatal, it weakens shrimp and can lead to economic losses. Preventing the disease involves maintaining clean water, reducing stress, and removing infected shrimp.",
    tips: [
      "Improve water quality by regular filtration and aeration.",
      "Minimize handling and injuries to prevent infections.",
      "Use probiotics and maintain proper stocking density.",
      "Remove affected shrimp to prevent disease spread."
    ]
  }
};

export default diseasesData;
